module.exports = __webpack_public_path__ + "static/img/product_mashine.cfab084.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/product_mashine.png
// module id = FKoQ
// module chunks = 1